const mapping = {
  1: 'day-sun',
  2: 'day-sun',
  3: 'day-small-cloud-sun',
  4: 'day-small-cloud-sun',
  5: 'day-small-cloud-sun',
  6: 'day-cloud-sun',
  7: 'day-cloud',
  8: 'day-cloud',
  9: null,
  10: null,
  11: 'day-mist',
  12: 'day-cloud-shower',
  13: 'day-cloud-sun-shower',
  14: 'day-cloud-sun-shower',
  15: 'day-cloud-thunder',
  16: 'day-cloud-sun-thunder',
  17: 'day-cloud-sun-thunder',
  18: 'day-cloud-rain',
  19: 'day-cloud-light-snow',
  20: 'day-cloud-sun-light-snow',
  21: 'day-cloud-sun-light-snow',
  22: 'day-cloud-snow',
  23: 'day-cloud-sun-snow',
  24: null,
  25: 'day-cloud-light-snow',
  26: 'day-cloud-rain',
  27: null,
  28: null,
  29: 'day-cloud-snow-rain',
  30: null,
  31: null,
  32: 'day-wind',
  33: 'night-moon',
  34: 'night-small-cloud-moon',
  35: 'night-small-cloud-moon',
  36: 'night-cloud-moon',
  37: 'night-mist',
  38: 'night-cloud-moon',
  39: 'night-cloud-moon-shower',
  40: 'night-cloud-moon-shower',
  41: 'night-cloud-moon-thunder',
  42: 'night-cloud-moon-thunder',
  43: 'night-cloud-moon-light-snow',
  44: 'night-cloud-moon-snow',
};

export default mapping;
